import type { EdgeId, PathLookupEdgeData } from '../edges';
import type { PathLookupNodeData } from '../nodes';
import type { NodeId } from '../nodes/types';
import type {
  PathLookupCheckExistence,
  PathLookupDeviceDecisionsMap,
  PathLookupEventsSummary,
  PathLookupPassingTraffic,
} from '../pathLookup';

export interface PathLookupGraphData {
  nodes: Record<NodeId, PathLookupNodeData>;
  edges: Record<EdgeId, PathLookupEdgeData>;
}

export interface GraphPathLookupResult {
  check: PathLookupCheckExistence;
  decisions: PathLookupDeviceDecisionsMap;
  eventsSummary: PathLookupEventsSummary;
  passingTraffic: PathLookupPassingTraffic;
}
